import setInboxAndSweepRulesService from '../services/setInboxAndSweepRulesService';
import { InboxRulesListOptionState } from '../store/schema/InboxRulesListOptionState';
import store from '../store/store';
import { select } from 'satcheljs/lib/legacy';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import datapoints from '../datapoints';

export interface SetInboxRulesOptionState {
    optionState: InboxRulesListOptionState;
}
/**
 * Saves the current inbox rule configuration
 */
export default select<SetInboxRulesOptionState>({
    optionState: () => store.inboxRulesListState,
})(
    createLegacyActionWithDatapoint('setInboxRules', datapoints.setInboxRulesDatapoint)(
        function setInboxRules(state?: SetInboxRulesOptionState): Promise<void> {
            let { optionState } = state;
            let inboxRuleIds = optionState.inboxRuleIds;
            let inboxRuleMap = optionState.inboxRules;

            return setInboxAndSweepRulesService(inboxRuleIds, inboxRuleMap)
                .then(response => {
                    if (!response.WasSuccessful) {
                        let errorMessage = response.ErrorMessage
                            ? response.ErrorMessage
                            : 'Response WasSuccessful was false';
                        return Promise.reject(new Error(errorMessage));
                    }
                    return Promise.resolve();
                })
                .catch(error => {
                    return Promise.reject(error);
                });
        }
    )
);
